const zhCN = {
  createQRCodeFail: '生成二维码失败！',

  downloadBtn: '下载二维码',
  QRCodeFileName: '二维码',

  refreshQRCode: '刷新二维码'
}
const enUS = {
  createQRCodeFail: 'Create QR code failed!',

  downloadBtn: 'Download',
  QRCodeFileName: 'QR code',

  refreshQRCode: 'Refresh QR Code'
}

export default { zhCN, enUS }